import React from 'react';
import { Modal, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import { InfoEvents } from './EventsView';
import { SingleWindow } from '../../../../store/Window';
import { IEventsItemProperties } from '../../../../store/EventsOpen/types';

const { Title } = Typography;

interface EventsCardModalProps {
  card: SingleWindow<IEventsItemProperties>;
}

export const EventsCardModal: React.FC<EventsCardModalProps> = observer(
  ({ card }) => {
    if (!card.window?.visible) return <></>;

    const {
      title,
      date_end,
      date_start,
      photos,
      sale_link,
      organizer,
      description,
      age,
      price,
      municipal_district_title,
    } = card.window.data;

    return (
      <Modal
        width={900}
        open={card.window.visible}
        title={
          <Title style={{ paddingRight: 12 }} level={5}>
            {title}
          </Title>
        }
        onCancel={card.close}
        footer={<div></div>}
        classNames={{ container: 'card-view-modal' }}
        styles={{
          body: { height: 600, padding: 0, overflow: 'hidden auto' },
        }}
      >
        <InfoEvents
          description={description}
          dateEnd={date_end}
          dateStart={date_start}
          price={price}
          age={age}
          organizer={organizer}
          saleLink={sale_link}
          photos={photos}
          municipalDistrictTitle={municipal_district_title}
        />
      </Modal>
    );
  },
);
